"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageIntegrationTypes = void 0;
exports.SetPageIntegrationTypes = [
    "analytics",
    "pixel-tracking",
    "mailing-list",
    "seo",
    //"social-media",
    //"custom-css",
    //"popups",
    "quick-links",
];
//# sourceMappingURL=types.js.map